import { DataGrid, DataGridLayout } from '@verantos-dev/shared-components';
import { theme } from '@verantos-dev/shared-styles';
import { IsValidCreateUploadResponse } from '@verantos-dev/types-concepts';

import { useValidationResultsGrid } from '../hooks/useValidationResultsGrid';

interface ValidationResultsGridProps {
  concepts?: IsValidCreateUploadResponse[];
}

export default function ValidationResultsGrid({ concepts }: ValidationResultsGridProps) {
  const { conceptsSorted, columns } = useValidationResultsGrid(concepts);

  return (
    <DataGridLayout id="validation-results-datagrid-layout" sx={{ maxHeight: '450px' }}>
      <DataGrid
        id="validation-results"
        mode="client"
        disableSearchParamSync
        preventUrlReadWhenSyncDisabled={true}
        initialState={{ filter: { filterModel: { items: [] } } }}
        getRowId={(row) => row.conceptId}
        columns={columns}
        rows={conceptsSorted}
        pageSizeOptions={[25, 50, 100]}
        initialPageSize={25}
        pagination
        getRowClassName={(params) => {
          return !params.row.isValid ? 'MuiDataGrid-row-error' : '';
        }}
        useFetchDataGridData={() => {
          /* no-op */
        }}
        sx={{
          '& .MuiDataGrid-row-error': {
            backgroundColor: '#fdf2f1',
            '&:nth-of-type(odd)': {
              backgroundColor: '#fdf2f1',
              '&:hover': {
                backgroundColor: '#fdf2f1',
              },
            },
            '&:hover': {
              backgroundColor: '#fdf2f1',
            },
            '& .MuiDataGrid-cell': {
              color: theme.palette.error.main,
            },
          },
          '& .MuiDataGrid-row': {
            '--rowBorderColor': theme.palette.divider,
          },
        }}
      />
    </DataGridLayout>
  );
}
